module.exports = __webpack_public_path__ + "img/Forma 7 copia 3.ce9ae430.svg";